import { observable, computed } from "mobx";
import { Currency } from "util/Currency";
import { helpers } from "aaa";

export const SALUTATIONS = [
    "mr",
    "mrs"
];

export const TITLES = [
    "dr.",
    "prof.",
    "prof.dr."
];

export const COUNTRIES = [
    "germany"
];

export const MARITAL_STATUS = [
    "marital.single",
    "marital.married",
    "marital.separated",
    "marital.divorced",
    "marital.widow",
    "marital.partnership",
];

export const RESIDENCE_STATUS = [
    "residence.owner",
    "residence.rent",
    "residence.atParents"
];

export const EMPLOYMENT_TYPES = [
    "employment.employee",
    "employment.worker",
    "employment.civilServant",
    "employment.retired",
    "employment.private",
    "employment.other"
];


export class Employment {
    employment: string = "";
    employmentDetail: string = "";
    job: string = "";
    employer: string = "";
    employedSince: string = "";

    get employmentKey() {
        const index = helpers.indexOfStringInKeyArray(this.employment, EMPLOYMENT_TYPES);
        return index ? EMPLOYMENT_TYPES[index] : "";
    }
}

export class User {
    // Base data
    salutation: string = "";
    title: string = "";
    lastName: string = "";
    firstName: string = "";
    country: string = "";
    @observable address: string = "";
    @observable zipCode: string = "";
    @observable residence: string = "";
    birthDate: string = "";

    gdprAccepted = false;
    wantsClimateBonus = false;

    @observable secondBorrowerToggled = false;
    @observable ownerOfObject = false;

    get hasSecondBorrower() {
        return this.secondBorrowerToggled ||
            (
                this.secondBorrowerSalutation !== undefined &&
                this.secondBorrowerLastName !== undefined &&
                this.secondBorrowerFirstName !== undefined
            );
    }

    @computed get secondBorrowerName() {
        return (this.secondBorrowerFirstName && this.secondBorrowerLastName) ? this.secondBorrowerFirstName + " " + this.secondBorrowerLastName : "";
    }

    get name() {
        return this.firstName + " " + this.lastName;
    }

    secondBorrowerSalutation?: string;
    secondBorrowerTitle?: string;
    @observable secondBorrowerLastName?: string;
    @observable secondBorrowerFirstName?: string;
    secondBorrowerBirthDate?: string;
    secondBorrowerEmployment = new Employment();
    secondBorrowerNetIncome = new Currency();

    @observable successfullySubmitted = false;

    // Object data
    objectAddress: string = "";
    objectZipAndResidence: string = "";
    objectDistrictCourt: string = "";
    objectRegister: string = "";
    objectSheetNumber: string = "";

    // Personal data
    maritalStatus: string = "";
    peopleInHousehold: number = 0;
    residenceStatus: string = "";
    residenceSince: string = "";
    citizenship: string = "";
    employment = new Employment();

    // Contact data
    phoneNumber: string = "";
    emailAddress: string = "";
    @observable iban: string = "";
    phoneAllowed: boolean = false;

    // Income data    
    income = new class {
        net = new Currency();
        childMoney = new Currency();
        rent = new Currency();
        other = new Currency();
        otherDescription: string = "";
    };

    // Expenses data
    expenses = new class {
        rent = new Currency();
        utilities = new Currency();
        otherLoans = new Currency();
        insurances = new Currency();
        healthInsurance = new Currency();
        numberOfCars: number = 0;
        other = new Currency();
        otherDescription: string = "";
    };

    get residenceStatusKey() {
        const index = helpers.indexOfStringInKeyArray(this.residenceStatus, RESIDENCE_STATUS);
        return index ? RESIDENCE_STATUS[index] : "";
    }
}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/models/User.ts